import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateRefundMutation } from "../graphql/mutations";
import type {
  CreateRefundMutationType,
  CreateRefundMutationVariablesType,
} from "@/types/graphql/admin.generated";

export const useCreateRefundMutation = (
  options?: MutationHookOptions<
    CreateRefundMutationType,
    CreateRefundMutationVariablesType
  >
) => {
  return useMutation<
    CreateRefundMutationType,
    CreateRefundMutationVariablesType
  >(CreateRefundMutation, options);
};
